import { Camera } from "lucide-react";

export const PhotoSlot = ({ src, alt, label = "Repair photo to be added", tone = "dark", className = "" }) => {
  if (src) return <img src={src} alt={alt} loading="lazy" className={`h-full w-full object-cover ${className}`} />;
  return (
    <div role="img" aria-label={`${alt} (photo coming soon)`} className={`metal h-full w-full flex flex-col items-center justify-center gap-3 text-center ${tone === "light" ? "brightness-125" : ""} ${className}`}>
      <Camera className="h-7 w-7 text-[var(--mute)]" aria-hidden />
      <span className="font-mono text-xs uppercase tracking-[0.2em] text-[var(--mute)] px-4">{label}</span>
    </div>
  );
};
